import type { JSX } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { PlaceField } from 'src/app/shared/components/googlePlaces';

import { useLocation } from './hooks/useLocation';

export function Location(): JSX.Element | null {
	const { translate } = useI18n();
	const { data, actions } = useLocation();

	if (data.geoReach !== 'local') return null;

	return (
		// TODO: All the styling changes made below for the PlaceField component should be cleaned when we migrate this component to use the new DS components.
		<div
			id="petition_location"
			className="-mt-4 [&#petition-place+div]:!mt-2.5 [&_#petition-place]:h-[52px] [&_#petition-place]:font-sans [&_label_span]:font-sans [&_label_span]:text-size-body-small [&_label_span]:text-typography-strong"
		>
			<PlaceField
				label={translate('corgi.petition.edit.petition_data.location.title')}
				geoScope={data.geoReach}
				onSelect={actions.onSelect}
				defaultPlaceValue={data.place}
				error={data.error ? translate(data.error) : null}
			/>
		</div>
	);
}
